import React from 'react';
import { Tooltip } from 'antd';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import './styles.css';

const DocumentTitle = ({ isMobile }) => {
    const { documentInfo, templateData, isTemplateDocument } = useDocument();
    const name = isTemplateDocument ? (templateData ? templateData.name : "Template") : (documentInfo ? documentInfo.name : "New Document");

    return (
        <div className="document-title-container">
            <Tooltip title={name}>
                <h1 className={`document-title-h1 ${isMobile ? 'mobile' : ''}`}>
                    {name}
                </h1>
            </Tooltip>
        </div>
    );
};

export default DocumentTitle;